var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 1.2583V4.26298L11.5239 4.28469C7.72258 4.64972 4.75 7.85287 4.75 11.75C4.75 15.8921 8.10786 19.25 12.25 19.25C16.1471 19.25 19.3503 16.2774 19.7153 12.4761L19.737 12.25H22.7417L22.7223 12.518C22.3289 17.9586 17.7907 22.25 12.25 22.25C6.45101 22.25 1.75 17.549 1.75 11.75C1.75 6.2093 6.04143 1.67112 11.482 1.27768L11.75 1.2583Z",
    stroke: "#172664",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9.5C22 5.35786 18.6421 2 14.5 2",
    stroke: "#172664",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnPieChart);
export default __webpack_public_path__ + "static/media/icn_pie_chart.a217858d2d312f91a2f543b633906fc0.svg";
export { ForwardRef as ReactComponent };